<template>
    <div>
        <v-dialog v-model="dialog_permission" persistent max-width="290">
          <v-card>
            <v-card-text class="pt-4">
                <div v-if="$parent.permissionType=='contact'">
                      {{ $t('dialogs.permissionContact') }}
                  </div>
                  <div v-if="$parent.permissionType=='storage'">
                      {{ $t('dialogs.permissionStorage') }}
                  </div>
                <div v-if="$parent.permissionType=='camera'">
                      {{ $t('dialogs.permissionCamera') }}
                  </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="$parent.fn_closeDialog">{{ $t('common.closeLower') }}</v-btn>
                  <v-btn color="primary" text @click.native="fn_permissionSettings">{{ $t('common.ok') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
</template>	 	

<script>

export default{
    data(){
        return{
            dialog_permission:false
        }
    },
    methods:{
        openDialogWeb: function () {
            this.dialog_permission = true;
        },
        closeDialogWeb: function () {
            this.dialog_permission = false;
        },
        fn_permissionSettings: function(){
            this.$parent.fn_closeDialog();
            // this.$root.fn_gotoPermissionSettings()
            this.getData('ShowPermissionSettings', this.$parent.permissionType, {
                onSuccess: function(response){
                  console.log(response);
                }, 
                onError: function(error){
                  console.log(error);
                }
            });
        }
    }
}
</script>